import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import Icon from "~/components/shared/Icon";
import ToolbarButton from "~/components/build/Show/components/ToolbarButton";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { resolveJobUrl } from "~/components/build/Show/lib/urlForView";
import { jobQueryOptions } from "~/components/build/Show/lib/queries/job";
import { useStepDrawer } from "~/components/build/Show/components/StepDrawer/StepDrawerContext";
import { GoToFailure } from "~/components/build/Show/components/StepDrawer/GoToFailure";

const RetryJobNavigation = () => {
  const { build } = useBuild();
  const queryClient = useQueryClient();
  const { job, retries } = useStepDrawer();

  if (!job) {
    return null;
  }

  const index = retries.findIndex((retry) => retry.id === job.id);

  const prev = retries[index - 1];
  const next = retries[index + 1];

  if (retries.length <= 1) {
    return null;
  }

  return (
    <div className="ml-auto flex items-center gap-2">
      <span className="text-xs">
        Retry <span className="tabular-nums">{index + 1}</span>
        {" of "}
        <span className="tabular-nums">{retries.length}</span>
      </span>

      <div className="flex gap-1">
        <Link
          data-testid="previous-retry-link"
          to={prev && resolveJobUrl(prev.id)}
          onMouseEnter={() => {
            if (Features.ProgressiveBuildShow && prev) {
              queryClient.prefetchQuery(jobQueryOptions(build, prev.id));
            }
          }}
          title="Previous"
          aria-disabled={!prev}
          className="text-inherit aria-disabled:pointer-events-none aria-disabled:text-gray-700"
        >
          <ToolbarButton>
            <Icon icon="heroicons/outline/chevron-left" className="h-4" />
          </ToolbarButton>
        </Link>
        <Link
          data-testid="next-retry-link"
          to={next && resolveJobUrl(next.id)}
          onMouseEnter={() => {
            if (Features.ProgressiveBuildShow && next) {
              queryClient.prefetchQuery(jobQueryOptions(build, next.id));
            }
          }}
          title="Next"
          aria-disabled={!next}
          className="text-inherit aria-disabled:pointer-events-none aria-disabled:text-gray-700"
        >
          <ToolbarButton>
            <Icon icon="heroicons/outline/chevron-right" className="h-4" />
          </ToolbarButton>
        </Link>
      </div>
    </div>
  );
};

export const DrawerActions = () => {
  return (
    <div className="flex flex-auto">
      <GoToFailure />
      <RetryJobNavigation />
    </div>
  );
};
